import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { UserService } from '../../services/user/user.service';
import { DocumentService } from '../../services/document/document.service';
import { Router } from '@angular/router';

interface Document {
  name: string;
  creationDate: string;
  modificationDate: string;
  type: string;
}

@Component({
  selector: 'app-form-history',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './form-history.component.html',
  styleUrls: ['./form-history.component.css']
})
export class FormHistoryComponent implements OnInit {
  isButtonDisabled = true;
  documents: any[] = [];
  itemsPerPage = 5;
  currentPage = 1;
  totalPages = 0;
  documentTypes: { [key: number]: string } = {
    1: 'Contrato de prestación de servicios',
    2: 'Acta de inicio',
    3: 'Acta de terminación',
    4: 'Otro tipo de documento'
  };
  statusLabels: { [key: string]: string } = {
    Completed: 'Completado',
    Draft: 'Incompleto',
    Failed: 'Fallido',
    Pending: 'Pendiente'
  };
  typeCreation: { [key: string]: string } = {
    Single: 'Individual',
    Batch: 'Masivo'
  };

  constructor(private userService: UserService, private documentService: DocumentService, private http: HttpClient, private router: Router) {}

  ngOnInit() {
    console.log('ngOnInit called');
    this.userService.getHistoryDocument().subscribe(
      (response) => {
        this.documents = response;
        this.totalPages = Math.ceil(this.documents.length / this.itemsPerPage); 
      },
      (error) => {
        console.error('Error al obtener los documentos:', error);
      }
    );
  }

  get totalPagesArray() {
    return Array(this.totalPages).fill(0);
  }

  get paginatedDocuments() {
    const start = (this.currentPage - 1) * this.itemsPerPage;
    return this.documents.slice(start, start + this.itemsPerPage);
  }

  previousPage() {
    if (this.currentPage > 1) {
      this.currentPage--;
    }
  }

  nextPage() {
    if (this.currentPage < this.totalPages) {
      this.currentPage++;
    }
  }

  goToPage(page: number) {
    this.currentPage = page;
  }

  generateDocument(doc: any) {
    const documentId = doc.id;
    const formId = doc.formId;
  
    this.userService.getUserInfo().subscribe({
      next: (userInfo) => {
        const headersData = {
          entityDocType: userInfo['custom:tipoDocEntidad'],
          entityDocNumber: userInfo['custom:numeroDocEntidad'],
          userDocType: userInfo['custom:tipoDoc'],
          userDocNumber: userInfo['custom:numeroDoc']
        };
  
        this.documentService.downloadDocument(documentId, formId, headersData).subscribe({
          next: (response) => {
            if (response?.url) {
              const link = document.createElement('a');
              link.href = response.url;
              link.download = '';
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
            }
          },
          error: (err) => {
            console.error('Error al generar documento:', err);
          }
        });
      },
      error: (err) => {
        console.error('Error al obtener datos del usuario:', err);
      }
    });
  }

  modifyDocument(doc: any) {
    const formId = doc.formId;
    const menuId = doc.menuId;
  
    this.documentService.getFormData(formId, menuId).subscribe({
      next: (response) => {
        const formData = response.formData;
        localStorage.setItem('cachedFormData', JSON.stringify(formData));
        if (menuId == 1) {
            this.router.navigate([`/individual-form/contract/contract${menuId}`], {
            queryParams: {
              formId: doc.formId,
              menuId: doc.menuId
            }
          });   
        }else if (menuId == 2) {
          this.router.navigate([`/individual-form/contract/starup${menuId}`], {
            queryParams: {
              formId: doc.formId,
              menuId: doc.menuId
            }
          });  
        }else{
          this.router.navigate([`/individual-form/contract/termination${menuId}`], {
            queryParams: {
              formId: doc.formId,
              menuId: doc.menuId
            }
          });
        }
            
      },
      error: (err) => {
        console.error('Error al obtener el formulario:', err);
        alert('No se pudo cargar el formulario.');
      }
    });
  }

  isGenerateDisabled(doc: any): boolean {
    return doc.formStatus === 'Draft';
  }

  isModifyDisabled(doc: any): boolean {
    return doc.typeRecord === 'Batch';
  }
}
